import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ValutakursService {

  readonly baseUrl: string = (window as any).env.serverPath;

  constructor(private readonly httpClient: HttpClient) { }

  getValutaKurser(valuta: string, utbetalningsdatum: { ar: string; manad: string; dag: string }) {
    let url = `/valutakurser/${valuta}/${utbetalningsdatum.ar}`;
    url = url.concat(utbetalningsdatum.manad === null ? '' : `/${utbetalningsdatum.manad}`);
    url = url.concat(utbetalningsdatum.dag === null ? '' : `/${utbetalningsdatum.dag}`);

    return this.httpClient
      .get(`${this.baseUrl}/valutakurs${url}`)
      .toPromise();
  }

  getNarmasteBankdag(stringDate: string): Promise<any> {
    const params = new HttpParams({
      fromObject: {
        narmastFran: stringDate
      }
    });
    return this.httpClient.get(this.baseUrl + '/valutakurs/bankdagar', {params})
      .toPromise();
  }
}
